import DiscountIcon from '@/assets/images/icons/DiscountIcon'
import { useTranslation } from 'react-i18next'

export function ReferralPerk({ type }: { type: string }) {
  const { t } = useTranslation()

  return (
    <div className="flex w-full grow flex-col rounded-xl border border-solid border-[#CACFD8] px-4 py-3">
      <h4 className="m-0 text-base font-medium leading-7 text-[#0e121b]">
        {t(`referrals.perks.${type}.title`)}
      </h4>
      <PerkRow>
        <p className="text-sm font-normal text-[#525866]">
          {t(`referrals.perks.${type}.perk_1`)}
        </p>
      </PerkRow>
      <PerkRow>
        <p className="text-sm font-normal text-[#525866]">
          {t(`referrals.perks.${type}.perk_2`)}
        </p>
      </PerkRow>
    </div>
  )
}

export default function ReferralPerks() {
  return (
    <div className="flex flex-nowrap gap-4">
      <ReferralPerk type="you" />
      <ReferralPerk type="they" />
    </div>
  )
}

function PerkRow({ children }: { children: React.ReactNode }) {
  return (
    <div className="my-1 flex items-center gap-2">
      <DiscountIcon />
      {children}
    </div>
  )
}
